import { create } from 'zustand';
import type { Avatar, DateInvite, DateLength } from '@/api/types';

export interface ComposerPrefill {
  length?: DateLength;
  /** 'now', or offer times (v6.2; 'later' is the v6.1 name). */
  when?: 'now' | 'times' | 'later';
  /** Where the invite came from (analytics-free; only changes copy). */
  source?: 'home' | 'friends' | 'wrap' | 'second_date';
  /** v9 K1: a direct invite to this connection (no link). See openDirectInvite. */
  to?: DirectPerson;
}

/** The connection a direct invite goes to; name/avatar are looked up from Friends when missing. */
export interface DirectPerson {
  id: string;
  display_name?: string;
  avatar?: Avatar;
}

interface ComposerState {
  /** The create sheet. */
  open: boolean;
  prefill: ComposerPrefill;
  /** The share sheet (after create, or "Share" from Friends → Dates). */
  shared: DateInvite | null;
  start: (prefill?: ComposerPrefill) => void;
  close: () => void;
  share: (inv: DateInvite) => void;
  closeShare: () => void;
}

/** One composer for the whole app: Home, Friends → Dates and the post-date wrap open the same sheets. */
export const useInviteComposer = create<ComposerState>((set) => ({
  open: false,
  prefill: {},
  shared: null,
  start: (prefill = {}) => set({ open: true, prefill, shared: null }),
  close: () => set({ open: false }),
  share: (inv) => set({ open: false, shared: inv }),
  closeShare: () => set({ shared: null }),
}));
